/// <reference types="./projects_table.d.mts" />
import * as $when from "../../../../app_config/app_config/when.mjs";
import * as $connector from "../../../../common/data/connector.mjs";
import * as $project from "../../../../common/data/project.mjs";
import * as $proposal from "../../../../common/data/proposal.mjs";
import * as $status from "../../../../common/data/status.mjs";
import * as $user from "../../../../common/data/user.mjs";
import * as $list_ from "../../../../common_common/gleam/list/extra.mjs";
import * as $timestamp_ from "../../../../common_common/gleam/time/timestamp/extra.mjs";
import * as $unsafe from "../../../../common_common/gleam/unsafe.mjs";
import * as $colors from "../../../../ds/ds/colors.mjs";
import * as $dropdown from "../../../../ds/ds/components/dropdown.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $portal from "../../../../ds/ds/components/portal.mjs";
import * as $pp from "../../../../ds/ds/components/profile_picture.mjs";
import * as $progress_bar from "../../../../ds/ds/components/progress/bar.mjs";
import * as $skeleton from "../../../../ds/ds/components/skeleton.mjs";
import * as $table from "../../../../ds/ds/components/table.mjs";
import * as $events from "../../../../ds/ds/events.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $position from "../../../../ds/ds/internals/position.mjs";
import * as $text from "../../../../ds/ds/typography/text.mjs";
import * as $ds_utils from "../../../../ds/ds/utils.mjs";
import * as $window from "../../../../ds/web/browser/window.mjs";
import * as $bool from "../../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $function from "../../../../gleam_stdlib/gleam/function.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $uri from "../../../../gleam_stdlib/gleam/uri.mjs";
import * as $level from "../../../../grille_pain/grille_pain/toast/level.mjs";
import * as $a from "../../../../lustre/lustre/attribute.mjs";
import * as $el from "../../../../lustre/lustre/element.mjs";
import * as $h from "../../../../lustre/lustre/element/html.mjs";
import * as $e from "../../../../lustre/lustre/event.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import { px } from "../../../../sketch/sketch/css/length.mjs";
import * as $html from "../../../../sketch_lustre/sketch/lustre/element/html.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $route from "../../../data/route.mjs";
import * as $warn from "../../../frontend/error/warn.mjs";
import * as $common from "../../../frontend/view/common.mjs";
import * as $sp from "../../../frontend/view/styles/proposals.mjs";
import {
  Ok,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
  isEqual,
} from "../../../gleam.mjs";

export class ShowMenu extends $CustomType {}

export class HideMenu extends $CustomType {}

export class Props extends $CustomType {
  constructor(user, menu_opened, menu_visible, projects, projects_opened, proposals_editable, proposals_loading, route, users) {
    super();
    this.user = user;
    this.menu_opened = menu_opened;
    this.menu_visible = menu_visible;
    this.projects = projects;
    this.projects_opened = projects_opened;
    this.proposals_editable = proposals_editable;
    this.proposals_loading = proposals_loading;
    this.route = route;
    this.users = users;
  }
}

export class ProjectProps extends $CustomType {
  constructor(project, proposals, opened, completion) {
    super();
    this.project = project;
    this.proposals = proposals;
    this.opened = opened;
    this.completion = completion;
  }
}

function attachments(project) {
  return $list.map(
    project.metadata.attachments,
    (attachment) => {
      let icon = $ds_utils.select_icon(
        attachment.content_type,
        new $connector.Steerlab(),
      );
      return $sp.small_button(
        toList([$a.style("pointer-events", "none")]),
        toList([$icons.tiny(icon), $el.text(attachment.name)]),
      );
    },
  );
}

function click_on_id(id) {
  return $decode.then$(
    $decode.dynamic,
    (_) => {
      $window.click_on(id);
      return $decode.failure($unsafe.coerce(""), "");
    },
  );
}

function on_toggle_collapse(project) {
  let _pipe = new $msg.UserToggledCollapsedProject(project);
  let _pipe$1 = new $msg.Project(_pipe);
  return $e.on_click(_pipe$1);
}

function owner(owner, users) {
  let user = $list.find(users, (u) => { return u.id === owner; });
  return $when.ok(
    user,
    (_use0) => {
      let name = _use0.name;
      let picture = _use0.picture;
      let initials = _use0.initials;
      return $common.name_small(
        toList([]),
        toList([
          $pp.from_user(picture, initials, new $pp.Medium()),
          $el.text(name),
        ]),
      );
    },
  );
}

function collaborators(collaborators, users) {
  if (collaborators instanceof $Empty) {
    return $el.none();
  } else {
    let $ = collaborators.tail;
    if ($ instanceof $Empty) {
      let user_id = collaborators.head;
      return owner(user_id, users);
    } else {
      let users_id = collaborators;
      return $common.stacked_avatars(users_id, users);
    }
  }
}

function on_more_click(id) {
  return $e.on(
    "click",
    $decode.then$(
      $decode.dynamic,
      (event) => {
        let $ = $position.get_event_bounding_client_rect(event);
        if ($ instanceof Ok) {
          let rect = $[0];
          let _pipe = new $msg.UserToggledProposalMenu(id, rect);
          let _pipe$1 = new $msg.Proposal(_pipe);
          return $decode.success(_pipe$1);
        } else {
          return $decode.failure($unsafe.coerce(""), "");
        }
      },
    ),
  );
}

function on_edit_proposal(proposal) {
  let proposal_id = proposal.id;
  let project_id = proposal.project_id;
  let _pipe = new $route.EditProposal(project_id, proposal_id);
  let _pipe$1 = new $route.Projects(_pipe);
  let _pipe$2 = $route.to_uri(_pipe$1);
  let _pipe$3 = $uri.to_string(_pipe$2);
  return $a.href(_pipe$3);
}

function on_edit_project(project) {
  let id = project.id;
  let _pipe = new $route.EditProject(id);
  let _pipe$1 = new $route.Projects(_pipe);
  let _pipe$2 = $route.to_uri(_pipe$1);
  let _pipe$3 = $uri.to_string(_pipe$2);
  return $a.href(_pipe$3);
}

function project_actions_popup(props, project_props) {
  return $when.some(
    props.menu_opened,
    (_use0) => {
      let proposal_id = _use0[0];
      let rect = _use0[1];
      let project = project_props.project;
      return $bool.lazy_guard(
        project.id !== proposal_id,
        $el.none,
        () => {
          let on_export = $e.on_click(
            new $msg.Project(new $msg.UserExportedProject(project.id)),
          );
          let on_delete$1 = $e.on_click(
            new $msg.Project(new $msg.UserWillDeleteProject(project.id)),
          );
          return $portal.portal(
            1000,
            $sp.actions_popup(
              new Some(rect),
              toList([]),
              toList([
                $sp.action_title(toList([]), toList([$h.text("Actions")])),
                $sp.action_option(
                  toList([on_export]),
                  toList([
                    $sp.details_collaborators_icon($icons.export$()),
                    $h.text("Export project"),
                  ]),
                ),
                (() => {
                  let $ = project.status;
                  if ($ instanceof $status.InProgress) {
                    return $sp.action_link(
                      toList([on_edit_project(project)]),
                      toList([
                        $sp.details_collaborators_icon($icons.edit_line()),
                        $h.text("Edit project"),
                      ]),
                    );
                  } else {
                    return $el.none();
                  }
                })(),
                $sp.action_option(
                  toList([on_delete$1]),
                  toList([
                    $sp.details_collaborators_icon($icons.trash()),
                    $h.text("Delete project"),
                  ]),
                ),
              ]),
            ),
          );
        },
      );
    },
  );
}

function on_proposal_export(proposal) {
  return $e.on_click(
    (() => {
      let $ = proposal.metadata;
      if ($ instanceof $proposal.Portal) {
        return new $msg.ApplicationRequestedToDisplayToast(
          new $level.Error(),
          "This proposal was created using a portal. Please the use the portal to export it.",
        );
      } else if ($ instanceof $proposal.Document) {
        return new $msg.Docx(new $msg.GenerateDocx(proposal.id));
      } else if ($ instanceof $proposal.Questionnaire) {
        return new $msg.Xlsx(new $msg.GenerateXlsx(proposal.id));
      } else {
        return new $msg.ApplicationRequestedToDisplayToast(
          new $level.Error(),
          "You can only export proposals in Word or Excel format. Please reach out to the Steerlab team for support.",
        );
      }
    })(),
  );
}

function on_delete(id) {
  let _pipe = new $msg.UserDisplayedDeleteProposalModal(id);
  let _pipe$1 = new $msg.Proposal(_pipe);
  return $e.on_click(_pipe$1);
}

function project_proposal_actions_popup(props, project, proposal) {
  return $when.some(
    props.menu_opened,
    (_use0) => {
      let proposal_id = _use0[0];
      let rect = _use0[1];
      return $bool.lazy_guard(
        proposal.id !== proposal_id,
        $el.none,
        () => {
          let _block;
          let _pipe = on_proposal_export(proposal);
          _block = $e.stop_propagation(_pipe);
          let on_click_export_proposal = _block;
          let _block$1;
          let $ = props.proposals_editable;
          if ($) {
            _block$1 = on_delete(proposal_id);
          } else {
            let _pipe$1 = "Your permissions don't allow to delete a proposal. Please reach out to a proposal manager";
            let _pipe$2 = new Some(_pipe$1);
            let _pipe$3 = $warn.action_forbidden(_pipe$2);
            let _pipe$4 = $e.on_click(_pipe$3);
            _block$1 = $e.stop_propagation(_pipe$4);
          }
          let on_click_delete_proposal = _block$1;
          return $portal.portal(
            1000,
            $sp.actions_popup(
              new Some(rect),
              toList([]),
              toList([
                $sp.action_title(toList([]), toList([$h.text("Actions")])),
                $sp.action_option(
                  toList([on_click_export_proposal]),
                  toList([
                    $sp.details_collaborators_icon($icons.export$()),
                    $h.text("Export proposal"),
                  ]),
                ),
                (() => {
                  let $1 = props.user;
                  let $2 = project.status;
                  if ($2 instanceof $status.InProgress) {
                    if ($1 instanceof Some) {
                      let user = $1[0];
                      let disallowed = !$list.contains(project.owners, user.id);
                      let bypass = $list.any(
                        user.roles,
                        (role) => {
                          return (role.name === "Super Admin") || (role.name === "Admin");
                        },
                      );
                      return $bool.lazy_guard(
                        disallowed || !bypass,
                        $el.none,
                        () => {
                          return $l.fragment(
                            toList([
                              $sp.action_link(
                                toList([on_edit_project(project)]),
                                toList([
                                  $sp.details_collaborators_icon(
                                    $icons.edit_line(),
                                  ),
                                  $h.text("Edit project"),
                                ]),
                              ),
                              $sp.action_link(
                                toList([on_edit_proposal(proposal)]),
                                toList([
                                  $sp.details_collaborators_icon(
                                    $icons.edit_line(),
                                  ),
                                  $h.text("Edit proposal"),
                                ]),
                              ),
                            ]),
                          );
                        },
                      );
                    } else {
                      return $el.none();
                    }
                  } else {
                    return $el.none();
                  }
                })(),
                $sp.action_option(
                  toList([on_click_delete_proposal]),
                  toList([
                    $sp.details_collaborators_icon($icons.trash()),
                    $h.text("Delete proposal"),
                  ]),
                ),
              ]),
            ),
          );
        },
      );
    },
  );
}

function proposal_actions_popup(props, project, proposal) {
  return $when.some(
    props.menu_opened,
    (_use0) => {
      let proposal_id = _use0[0];
      let rect = _use0[1];
      return $bool.lazy_guard(
        proposal.id !== proposal_id,
        $el.none,
        () => {
          let _block;
          let _pipe = on_proposal_export(proposal);
          _block = $e.stop_propagation(_pipe);
          let on_click_export_proposal = _block;
          let _block$1;
          let $ = props.proposals_editable;
          if ($) {
            _block$1 = on_delete(proposal_id);
          } else {
            let _pipe$1 = "Your permissions don't allow to delete a proposal. Please reach out to a proposal manager";
            let _pipe$2 = new Some(_pipe$1);
            let _pipe$3 = $warn.action_forbidden(_pipe$2);
            let _pipe$4 = $e.on_click(_pipe$3);
            _block$1 = $e.stop_propagation(_pipe$4);
          }
          let on_click_delete_proposal = _block$1;
          return $portal.portal(
            1000,
            $sp.actions_popup(
              new Some(rect),
              toList([]),
              toList([
                $sp.action_title(toList([]), toList([$h.text("Actions")])),
                $sp.action_option(
                  toList([on_click_export_proposal]),
                  toList([
                    $sp.details_collaborators_icon($icons.export$()),
                    $h.text("Export proposal"),
                  ]),
                ),
                (() => {
                  let $1 = props.user;
                  let $2 = project.status;
                  if ($2 instanceof $status.InProgress) {
                    if ($1 instanceof Some) {
                      let user = $1[0];
                      let disallowed = !$list.contains(project.owners, user.id);
                      let bypass = $list.any(
                        user.roles,
                        (role) => {
                          return (role.name === "Super Admin") || (role.name === "Admin");
                        },
                      );
                      return $bool.lazy_guard(
                        disallowed || !bypass,
                        $el.none,
                        () => {
                          return $sp.action_link(
                            toList([on_edit_proposal(proposal)]),
                            toList([
                              $sp.details_collaborators_icon($icons.edit_line()),
                              $h.text("Edit proposal"),
                            ]),
                          );
                        },
                      );
                    } else {
                      return $el.none();
                    }
                  } else {
                    return $el.none();
                  }
                })(),
                $sp.action_option(
                  toList([on_click_delete_proposal]),
                  toList([
                    $sp.details_collaborators_icon($icons.trash()),
                    $h.text("Delete proposal"),
                  ]),
                ),
              ]),
            ),
          );
        },
      );
    },
  );
}

function status_dropdown(props, subject, status) {
  let disabled = isEqual(
    props.route,
    new $route.ContentLibrary(new $route.PreviousProposals())
  );
  let _block;
  if (status instanceof $status.InProgress) {
    _block = "Finalize";
  } else if (status instanceof $status.Won) {
    _block = $status.to_string(status);
  } else if (status instanceof $status.Lost) {
    _block = $status.to_string(status);
  } else if (status instanceof $status.Submitted) {
    _block = $status.to_string(status);
  } else {
    _block = $status.to_string(status);
  }
  let placeholder = _block;
  let _block$1;
  let _pipe = $status.all;
  let _pipe$1 = $list.filter(_pipe, (s) => { return !isEqual(s, status); });
  _block$1 = $list.map(
    _pipe$1,
    (s) => { return $dropdown.choice($status.to_string(s), s); },
  );
  let statuses = _block$1;
  let _pipe$2 = $sp.dropdown_wrapper(
    1.0,
    toList([$ds_utils.stop_propagation()]),
    toList([
      $dropdown.dropdown(
        (_capture) => {
          return new $msg.UserDisplayedModalChangeProjectStatus(
            subject.id,
            _capture,
          );
        },
        toList([
          $dropdown.selected(new Some(status)),
          $dropdown.input_class(
            $css.class$(toList([$css.color($colors.light.grey_800)])),
          ),
          $dropdown.placeholder(placeholder),
          $dropdown.disabled(disabled),
          $dropdown.icon($icons.checkmark()),
        ]),
        statuses,
      ),
    ]),
  );
  return $el.map(_pipe$2, (var0) => { return new $msg.Project(var0); });
}

function status_and_progress(props, subject, completion, status) {
  return $l.row(
    toList([$l.gap(12), $l.align("center")]),
    toList([]),
    toList([
      status_dropdown(props, subject, status),
      $html.div(
        $css.class$(toList([$css.min_width(px(80))])),
        toList([]),
        toList([$progress_bar.progress(completion)]),
      ),
    ]),
  );
}

function only_status(props, subject, status) {
  return $l.row(
    toList([$l.gap(12), $l.align("center")]),
    toList([]),
    toList([
      status_dropdown(props, subject, status),
      $html.div($css.class$(toList([])), toList([]), toList([])),
    ]),
  );
}

function progress(props, subject, completion, status) {
  let $ = props.route;
  let $1 = props.proposals_editable;
  if ($ instanceof $route.Overview) {
    return $progress_bar.progress(completion);
  } else if ($ instanceof $route.Projects) {
    let $2 = $[0];
    if ($2 instanceof $route.OnGoing) {
      if ($1) {
        if (completion === 100) {
          return status_and_progress(props, subject, completion, status);
        } else {
          return $progress_bar.progress(completion);
        }
      } else {
        return $progress_bar.progress(completion);
      }
    } else if ($2 instanceof $route.Previous) {
      if ($1) {
        let x = completion;
        if (x < 100) {
          return status_and_progress(props, subject, completion, status);
        } else {
          return only_status(props, subject, status);
        }
      } else {
        return only_status(props, subject, status);
      }
    } else {
      return only_status(props, subject, status);
    }
  } else {
    return only_status(props, subject, status);
  }
}

function empty_cell(child) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
      $css.padding_("30px 0"),
    ]),
  );
  return $html.div(_pipe, toList([]), toList([child]));
}

function empty_text_content(child) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.xs($text.medium)),
      $css.max_width(px(300)),
      $css.white_space("wrap"),
      $css.text_align("center"),
      $css.color($colors.light.grey_800),
    ]),
  );
  return $html.div(_pipe, toList([]), toList([child]));
}

const empty_text = "After you upload a proposal, it will appear here.";

function status_header(props) {
  let $ = props.route;
  if ($ instanceof $route.Overview) {
    return $table.header("Progress");
  } else if ($ instanceof $route.Projects) {
    let $1 = $[0];
    if ($1 instanceof $route.OnGoing) {
      return $table.header("Progress");
    } else {
      return $table.header("Status");
    }
  } else {
    return $table.header("Status");
  }
}

export function table(props) {
  return $table.table(
    toList([]),
    toList([
      $table.headers(
        toList([
          (() => {
            let _pipe = $table.header("");
            return $table.fit(_pipe);
          })(),
          $table.header("Name"),
          $table.header("Client"),
          (() => {
            let _pipe = $table.header("Creation Date");
            return $table.fit(_pipe);
          })(),
          (() => {
            let _pipe = $table.header("Due Date");
            return $table.fit(_pipe);
          })(),
          $table.header("Owners"),
          $table.header("Collaborators"),
          status_header(props),
          (() => {
            let _pipe = $table.header("");
            return $table.fit(_pipe);
          })(),
        ]),
      ),
      body(props),
    ]),
  );
}

function loading_table() {
  return $table.body(
    (() => {
      let _pipe = $table.row(
        (() => {
          let _pipe = $skeleton.skeleton(100, 25);
          let _pipe$1 = $table.cell(_pipe);
          return $list.repeat(_pipe$1, 9);
        })(),
      );
      let _pipe$1 = $table.hover(_pipe, false);
      return $list.repeat(_pipe$1, 5);
    })(),
  );
}

function attachments_row(project) {
  let id = "my-awesome-id-you-ll-never-find-" + project.id;
  let _pipe = $table.sub_row(
    (() => {
      let _pipe = $table.row(
        toList([
          $table.cell($el.none()),
          (() => {
            let _pipe = $table.cell(
              $l.row(
                toList([
                  $l.align("center"),
                  $l.gap(8),
                  $l.justify("space-between"),
                ]),
                toList([]),
                toList([
                  $l.row(
                    toList([$l.gap(8), $l.align("baseline"), $l.wrap("wrap")]),
                    toList([]),
                    toList([
                      $html.div(
                        $text.sm($text.medium),
                        toList([]),
                        toList([$el.text("Attachments")]),
                      ),
                      $l.fragment(attachments(project)),
                      $html.label_(
                        toList([]),
                        toList([
                          $sp.small_button(
                            toList([$e.on("click", click_on_id(id))]),
                            toList([
                              $icons.tiny($icons.add()),
                              $el.text("Add an attachment"),
                            ]),
                          ),
                          $html.input(
                            $css.class$(toList([$css.display("none")])),
                            toList([
                              $a.type_("file"),
                              $a.id(id),
                              $events.on_files_change(
                                (files) => {
                                  let _pipe = new $msg.UserAddedAttachments(
                                    project.id,
                                    files,
                                  );
                                  let _pipe$1 = new $msg.Project(_pipe);
                                  return $decode.success(_pipe$1);
                                },
                              ),
                            ]),
                          ),
                        ]),
                      ),
                    ]),
                  ),
                ]),
              ),
            );
            return $table.span(_pipe, 8);
          })(),
        ]),
      );
      return $table.hover(_pipe, false);
    })(),
  );
  return $table.separator(_pipe, false);
}

function proposal_menu_button(props, project, proposal) {
  let $ = props.menu_visible;
  if ($ instanceof ShowMenu) {
    let on_click = on_more_click(proposal.id);
    let _pipe = $sp.proposal_actions(
      toList([]),
      toList([
        $sp.more_icon_button(
          toList([on_click]),
          toList([$icons.tiny($icons.more())]),
        ),
        project_proposal_actions_popup(props, project, proposal),
      ]),
    );
    let _pipe$1 = $table.cell(_pipe);
    let _pipe$2 = $table.justify(_pipe$1, "end");
    let _pipe$3 = $table.class$(_pipe$2, $position.wrapper_class);
    return $table.stop_cell_propagation(_pipe$3);
  } else {
    return $table.cell($el.none());
  }
}

function proposal_row(props, project, proposal, completion) {
  let _pipe = $table.row(
    toList([
      $table.cell($el.none()),
      $table.cell(
        $l.row(
          toList([$l.align("center"), $l.gap(6)]),
          toList([]),
          toList([$icons.tiny($icons.proposal_file()), $el.text(project.name)]),
        ),
      ),
      $table.cell($el.text(project.client)),
      $table.cell($el.text($timestamp_.to_locale_full_date(project.created_at))),
      $table.cell($el.text($timestamp_.to_locale_full_date(project.deadline))),
      $table.cell(collaborators(project.owners, props.users)),
      $table.cell(collaborators(project.collaborators, props.users)),
      $table.cell(progress(props, project, completion, project.status)),
      proposal_menu_button(props, project, proposal),
    ]),
  );
  return $table.on_click(
    _pipe,
    new $msg.Proposal(new $msg.UserClickedProposal(proposal, new None())),
  );
}

function proposal_submenu_button(props, project, proposal) {
  let $ = props.menu_visible;
  if ($ instanceof ShowMenu) {
    let on_click = on_more_click(proposal.id);
    let _pipe = $sp.proposal_actions(
      toList([]),
      toList([
        $sp.more_icon_button(
          toList([on_click]),
          toList([$icons.tiny($icons.more())]),
        ),
        proposal_actions_popup(props, project, proposal),
      ]),
    );
    let _pipe$1 = $table.cell(_pipe);
    let _pipe$2 = $table.justify(_pipe$1, "end");
    let _pipe$3 = $table.class$(_pipe$2, $position.wrapper_class);
    return $table.stop_cell_propagation(_pipe$3);
  } else {
    return $table.cell($el.none());
  }
}

function proposal_sub_row(props, project, proposal) {
  return $table.row(
    toList([
      $table.cell($el.none()),
      (() => {
        let _pipe = $table.cell(
          $sp.padding_left(
            $l.row(
              toList([$l.align("center"), $l.gap(6)]),
              toList([]),
              toList([
                $icons.tiny($icons.proposal_file()),
                $el.text(proposal.name),
              ]),
            ),
          ),
        );
        return $table.span(_pipe, 6);
      })(),
      $table.cell($progress_bar.progress(proposal.progress)),
      proposal_submenu_button(props, project, proposal),
    ]),
  );
}

function proposals_sub_row(props, project_props) {
  return $bool.guard(
    !project_props.opened,
    toList([]),
    () => {
      return $list.map(
        project_props.proposals,
        (proposal) => {
          let _pipe = proposal_sub_row(props, project_props.project, proposal);
          let _pipe$1 = $table.on_click(
            _pipe,
            new $msg.Proposal(
              new $msg.UserClickedProposal(proposal, new None()),
            ),
          );
          return $table.sub_row(_pipe$1);
        },
      );
    },
  );
}

function project_menu_button(props, project_props) {
  let $ = props.menu_visible;
  if ($ instanceof ShowMenu) {
    let on_click = on_more_click(project_props.project.id);
    let _pipe = $sp.proposal_actions(
      toList([]),
      toList([
        $sp.more_icon_button(
          toList([on_click]),
          toList([$icons.tiny($icons.more())]),
        ),
        project_actions_popup(props, project_props),
      ]),
    );
    let _pipe$1 = $table.cell(_pipe);
    let _pipe$2 = $table.justify(_pipe$1, "end");
    let _pipe$3 = $table.class$(_pipe$2, $position.wrapper_class);
    return $table.stop_cell_propagation(_pipe$3);
  } else {
    return $table.cell($el.none());
  }
}

function project_row(props, project_props) {
  let project = project_props.project;
  let opened = project_props.opened;
  let completion = project_props.completion;
  let _block;
  let _pipe = $option.map(props.user, (u) => { return u.id; });
  _block = $option.unwrap(_pipe, "");
  let user = _block;
  let on_collapse = on_toggle_collapse(project);
  let _pipe$1 = listPrepend(
    (() => {
      let _pipe$1 = toList([$icons.medium($icons.arrow_up_line())]);
      let _pipe$2 = ((_capture) => {
        return $sp.collapse_icon_button(opened, toList([on_collapse]), _capture);
      })(_pipe$1);
      let _pipe$3 = $table.cell(_pipe$2);
      return $table.stop_cell_propagation(_pipe$3);
    })(),
    listPrepend(
      $table.cell(
        $l.row(
          toList([$l.align("center"), $l.gap(6)]),
          toList([]),
          toList([
            $icons.tiny($icons.folder()),
            $el.text(project_props.project.name),
          ]),
        ),
      ),
      listPrepend(
        $table.cell($el.text(project.client)),
        listPrepend(
          $table.cell(
            $el.text($timestamp_.to_locale_full_date(project.created_at)),
          ),
          listPrepend(
            $table.cell(
              $el.text($timestamp_.to_locale_full_date(project.deadline)),
            ),
            listPrepend(
              $table.cell(collaborators(project.owners, props.users)),
              listPrepend(
                $table.cell(collaborators(project.collaborators, props.users)),
                listPrepend(
                  $table.cell(
                    progress(props, project, completion, project.status),
                  ),
                  listPrepend(
                    (() => {
                      let $ = $list.contains(project.owners, user);
                      if ($) {
                        return project_menu_button(props, project_props);
                      } else {
                        return $table.cell($el.none());
                      }
                    })(),
                    proposals_sub_row(props, project_props),
                  ),
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  );
  let _block$1;
  if (opened) {
    _block$1 = (_capture) => {
      return $list_.insert(_capture, attachments_row(project));
    };
  } else {
    _block$1 = $function.identity;
  }
  let _pipe$2 = _block$1(_pipe$1);
  let _pipe$3 = $table.row(_pipe$2);
  return $table.hover(_pipe$3, false);
}

function empty_table() {
  let empty_cell$1 = empty_cell(empty_text_content($el.text(empty_text)));
  return $table.body(
    toList([
      (() => {
        let _pipe = $table.row(
          toList([
            (() => {
              let _pipe = $table.cell(empty_cell$1);
              return $table.span(_pipe, 10);
            })(),
          ]),
        );
        return $table.hover(_pipe, false);
      })(),
    ]),
  );
}

function body(props) {
  let projects = props.projects;
  let projects_opened = props.projects_opened;
  let proposals_loading = props.proposals_loading;
  return $bool.lazy_guard(
    proposals_loading,
    loading_table,
    () => {
      return $bool.lazy_guard(
        $list.is_empty(projects),
        empty_table,
        () => {
          return $table.body(
            $list.map(
              props.projects,
              (_use0) => {
                let project = _use0[0];
                let completion = _use0[1];
                let proposals = _use0[2];
                let $ = project.metadata.attachments;
                if (proposals instanceof $Empty) {
                  return $table.none();
                } else {
                  let $1 = proposals.tail;
                  if ($1 instanceof $Empty) {
                    if ($ instanceof $Empty) {
                      let p = proposals.head;
                      return proposal_row(props, project, p, completion);
                    } else {
                      let _pipe = $dict.get(projects_opened, project.id);
                      let _pipe$1 = $result.unwrap(_pipe, false);
                      let _pipe$2 = ((_capture) => {
                        return new ProjectProps(
                          project,
                          proposals,
                          _capture,
                          completion,
                        );
                      })(_pipe$1);
                      return ((_capture) => {
                        return project_row(props, _capture);
                      })(_pipe$2);
                    }
                  } else {
                    let _pipe = $dict.get(projects_opened, project.id);
                    let _pipe$1 = $result.unwrap(_pipe, false);
                    let _pipe$2 = ((_capture) => {
                      return new ProjectProps(
                        project,
                        proposals,
                        _capture,
                        completion,
                      );
                    })(_pipe$1);
                    return ((_capture) => {
                      return project_row(props, _capture);
                    })(_pipe$2);
                  }
                }
              },
            ),
          );
        },
      );
    },
  );
}
